<template>
<div class="chapter">
<div class="inner_page">
<div id="dedication">
<p class="center"><i>This book is dedicated to my precious son, Nathan, my wonderful daughters, Denay and Alisha, my two outstanding sons-in-law, Heighlos and Tim, and my two unbelievably adorable grandchildren, Soel and Sage.</i></p>
<p class="center"><i>Shelley and I love all of you more than words could possibly convey</i></p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006dedication.vue?1721fc36